import useCommonProps from './useCommonProps';
import { useMemo } from 'react';
import { useGetPerformerByEventOrByTimeout } from './useGetPerformerByEventOrByTimeout';
export var useGeneralProps = function () {
    var commonProps = useCommonProps();
    var performerByEventOrByTimeout = useGetPerformerByEventOrByTimeout();
    var generalProps = useMemo(function () { return ({
        commonProps: { sign: commonProps === null || commonProps === void 0 ? void 0 : commonProps.sign },
        performerByEventOrByTimeout: performerByEventOrByTimeout
    }); }, [commonProps === null || commonProps === void 0 ? void 0 : commonProps.sign, performerByEventOrByTimeout]);
    return generalProps;
};
//# sourceMappingURL=useGeneralProps.js.mapimport useCommonProps from './useCommonProps';
import { useMemo } from 'react';
import { useGetPerformerByEventOrByTimeout } from './useGetPerformerByEventOrByTimeout';
export var useGeneralProps = function () {
    var commonProps = useCommonProps();
    var performerByEventOrByTimeout = useGetPerformerByEventOrByTimeout();
    var generalProps = useMemo(function () { return ({
        commonProps: { sign: commonProps === null || commonProps === void 0 ? void 0 : commonProps.sign },
        performerByEventOrByTimeout: performerByEventOrByTimeout
    }); }, [commonProps === null || commonProps === void 0 ? void 0 : commonProps.sign, performerByEventOrByTimeout]);
    return generalProps;
};
//# sourceMappingURL=useGeneralProps.js.map